import changelogData from "../../../../../pages/travel-card/docs/changelog-travel-card.json5";
import * as React from 'react';
export default {
  changelogData,
  React
};